module.exports = __webpack_public_path__ + "img/isinova.d4fd2a23.jpg";